<template>
  <div>
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <Button type="primary" @click="handleAdd()">新建</Button>
        <el-select
          v-model="type"
          clearable
          placeholder="请选择承包商类别"
          @change="changeData"
          size="small"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="status"
          clearable
          placeholder="请选择黑名单状态"
          @change="changeData"
          size="small"
        >
          <el-option
            v-for="item in blackStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <Input
          search
          enter-button
          placeholder="请输入名称"
          v-model="fileNameOrTag"
          @on-search="getDangerPlan(1)"
          style="width: 300px"
        />
        <!--<Button type="primary" icon="ios-search" slot="append" @click="getDangerPlan(1)"></Button>-->
      </div>
      <div style="margin-top: 20px;">
        <Table :columns="columns" :data="data">
          <template slot-scope="{ row }" slot="blackStatus">
            <el-tag type="danger" size="small" v-if="row.blackStatus == 1">是</el-tag>
            <el-tag type="primary" size="small" v-if="row.blackStatus == 0">否</el-tag>
          </template>
          <template slot-scope="{ row }" slot="days">
            <el-tag type="danger" size="small">{{row.days}}</el-tag>
          </template>
          <template slot-scope="{ row }" slot="contrName">
            <el-button
              type="text"
              @click="showDrawer(row)"
              style="margin-right: 5px"
            >{{row.contrName}}</el-button>
          </template>
          <template slot-scope="{ row }" slot="action">
            <el-button type="text" @click="handChange(row)" style="margin-right: 5px">编辑</el-button>|
            <el-button type="text" @click="handleDel(row)" style="color: red">删除</el-button>
          </template>
        </Table>
        <div style="textAlign: right;margin-top: 10px">
          <Page :total="total" :page-size="pageSize" @on-change="getDangerPlan" />
        </div>
      </div>
      <el-drawer
        :visible.sync="drawer"
        size="83%"
        :modal="false"
        :before-close="handleClose"
        direction="rtl"
      >
        <span slot="title">
          <div style="margin-left: 1%">
            <span style="font-size: 20px">
              <b>{{infoForm.contrName}}</b>
            </span>
          </div>
          <div style="margin-top: 1%;margin-left: 1%">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>社会信用代码</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">
                  <span>{{infoForm.creditCode}}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>承包商类型</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">
                  <span v-if="infoForm.genre == 0">环境改造</span>
                  <span v-if="infoForm.genre == 1">工程检修安装</span>
                  <span v-if="infoForm.genre == 2">建筑施工</span>
                  <span v-if="infoForm.genre == 3">吊装作业</span>
                  <span v-if="infoForm.genre == 4">其他</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>合作状态</b>
                </div>
                <div
                  class="grid-content bg-purple"
                  style="margin-top: 3%"
                >{{infoForm.cooperationStatus}}</div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <b>承包商电话</b>
                </div>
                <div class="grid-content bg-purple" style="margin-top: 3%">{{infoForm.contrPhone}}</div>
              </el-col>
            </el-row>
          </div>
        </span>
        <div>
          <div style="margin-left: 1%">
            <el-tabs v-model="activeName" type="border-card" @tab-click='tabClick'>
              <el-tab-pane label="详情" name="first" style="height: 1000px">
                <el-form :model="infoForm" label-width="300px" style="overflow:auto;height: 500px">
                  <el-form-item label="名称：">
                    <span>{{infoForm.contrName}}</span>
                  </el-form-item>
                  <el-form-item label="社会信用代码：">
                    <span>{{infoForm.creditCode}}</span>
                  </el-form-item>
                  <el-form-item label="单位性质：">
                    <span>{{infoForm.contrNature}}</span>
                  </el-form-item>
                  <el-form-item label="承包商类别：">
                    <span v-if="infoForm.contrSort == 0">准承包商</span>
                    <span v-if="infoForm.contrSort == 1">合格承包商</span>
                    <span v-if="infoForm.contrSort == 2">不合格承包商</span>
                  </el-form-item>
                  <el-form-item label="承包商类型：">
                    <span v-if="infoForm.genre == 0">环境改造</span>
                    <span v-if="infoForm.genre == 1">工程检修安装</span>
                    <span v-if="infoForm.genre == 2">建筑施工</span>
                    <span v-if="infoForm.genre == 3">吊装作业</span>
                    <span v-if="infoForm.genre == 4">其他</span>
                  </el-form-item>
                  <el-form-item label="责任书到期时间：">
                    <span>{{infoForm.duetime}}</span>
                  </el-form-item>
                  <el-form-item label="经营范围：">
                    <span>{{infoForm.contrScope}}</span>
                  </el-form-item>
                  <el-form-item label="承包商电话：">
                    <span>{{infoForm.contrPhone}}</span>
                  </el-form-item>
                  <el-form-item label="邮箱：">
                    <span>{{infoForm.contrMail}}</span>
                  </el-form-item>
                  <el-form-item label="负责人：">
                    <span>{{infoForm.chargerName}}</span>
                  </el-form-item>
                  <el-form-item label="安全负责人：">
                    <span>{{infoForm.safetyCharger}}</span>
                  </el-form-item>
                  <el-form-item label="合作状态：">
                    <span>{{infoForm.cooperationStatus}}</span>
                  </el-form-item>
                  <el-form-item label="黑名单状态：">
                    <span v-if="infoForm.blackStatus == 0">否</span>
                    <span v-if="infoForm.blackStatus == 1">是</span>
                  </el-form-item>
                  <el-form-item label="资格证书编号：">
                    <span>{{infoForm.certificateNo}}</span>
                  </el-form-item>
                  <el-form-item label="资格证书：">
                    <el-link
                      v-for="(item1,index) in certificateStr"
                      type="primary" :key="index"
                      @click="downloadBtn(item1.url, item1.fileName)"
                    >{{item1.fileName}}&nbsp;&nbsp;&nbsp;</el-link>
                  </el-form-item>
                  <el-form-item label="附件：">
                    <el-link
                      v-for="(item1,index) in attachmentsStr"
                      type="primary" :key="index"
                      @click="downloadBtn(item1.url, item1.fileName)"
                    >{{item1.fileName}}&nbsp;&nbsp;&nbsp;</el-link>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="人员列表" name="second">
              <!-- <div>-->
              <!-- <Button type="primary" @click="()=>{this.userIsShow = true}"> 新建人员</Button>-->
              <!-- </div>-->

                <div>
                  <Table
                    border
                    style="margin: auto auto;"
                    height="650"
                    :columns="userCol"
                    :data="infoForm.employeeVos"
                  >
                    <template slot-scope="{ row }" slot="header">
                      <Avatar icon="ios-person" :src="host + row.image" />
                    </template>
                    <template slot-scope="{ row }" slot="sex">
                      <span>{{row.sex===0?"未知":row.sex===1?"男":"女"}}</span>
                    </template>
                  </Table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="人员证书" name="third">
                <el-table :data="infoForm.certificateVos" max-height="600" style="width: 100%">
                  <el-table-column prop="employeeVo.name" label="拥有者"></el-table-column>
                  <el-table-column prop="certificateNo" label="证书编号">
                    <template slot-scope="scope">
                      <!-- <a :download="scope.row.fileName" v-bind:href="scope.row.fileUrl">{{scope.row.certificateNo}}</a> -->
                      <span>{{ scope.row.certificateNo }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="issuingAuthority" label="发证机关"></el-table-column>
                  <el-table-column prop="authorizeProject" label="作业项目"></el-table-column>
                  <el-table-column prop="certificateType" label="证件类型">
                    <!-- <template slot-scope="scope">
                      <span v-if="scope.row.certificateType == 0">特级证书</span>
                      <span v-if="scope.row.certificateType == 1">一级证书</span>
                      <span v-if="scope.row.certificateType == 2">二级证书</span>
                      <span v-if="scope.row.certificateType == 3">三级证书</span>
                      <span v-if="scope.row.certificateType == 4">四级证书</span>
                      <span v-if="scope.row.certificateType == 5">五级证书</span>
                      <span v-if="scope.row.certificateType == 6">六级证书</span>
                    </template>-->
                  </el-table-column>
                  <el-table-column prop="getCertificateTime" label="领证日期"></el-table-column>
                  <el-table-column prop="expireTime" label="有效期"></el-table-column>
                  <el-table-column prop="reviewTime" label="复审日期"></el-table-column>
                  <el-table-column prop="nextReviewTime" label="下次复审日期"></el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="教育培训" name="fourth">
                <Table
                  border
                  style="margin: auto auto;"
                  max-height="600"
                  :columns="eduCol"
                  :data="infoForm.cultivateVos"
                ></Table>
              </el-tab-pane>
              <el-tab-pane label="考试记录" name="five">
                <Table
                  border
                  style="margin: auto auto;"
                  max-height="600"
                  :columns="examCol"
                  :data="infoForm.questionnaireVos"
                >
                  <template slot-scope="{ row }" slot="isExam">{{ row.answerStatus ? "是" : "否" }}</template>
                  <template slot-scope="{ row }" slot="isPass">{{ row.pass ? "通过" : "未通过" }}</template>
                </Table>
              </el-tab-pane>
              <el-tab-pane label="承包商施工管理" name="sixth">
                <el-button size="small" type="primary" style="margin-bottom: 15px" @click="drawerAddBtnSG">{{ tableStatusSG ? '新增' : '返回列表' }}</el-button>
                <!-- 承包商施工管理表格 -->
                <div style="height: 600px;overflow: auto">
                  <div v-if="tableStatusSG">
                    <Table
                      border
                      style="margin: auto auto;"
                      max-height="600"
                      :columns="constructionCol"
                      :data="constructionList"
                    >
                    <template slot-scope="{ row }" slot="doucumentSignTime">{{ row.doucumentSignTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="doucumentDueTime">{{ row.doucumentDueTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="intoPlantTime">{{ row.intoPlantTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="assessTime">{{ row.assessTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="blacklist">{{ row.blacklist === 0 ? "否" : "是" }}</template>
                    <template slot-scope="{ row }" slot="operation">
                      <el-link :underline="false" type="primary" @click="drawerEditSG(row)">编辑</el-link>
                      <span style="color: #e8e8e8; margin: 0 5px">|</span>
                      <el-link :underline="false" type="danger" @click="drawerDeleteSG(row.id)">删除</el-link>
                    </template>
                    </Table>
                    <div style="textAlign: right;margin-top: 10px">
                      <Page :current="drawerCurPageSG" :total="drawerTotalSG" :page-size="drawerPageSizeSG" @on-change="drawerPageChangeSG" />
                    </div>
                  </div>
                  <!-- 承包商施工管理新增/编辑的表单 -->
                  <el-form v-else :model="ruleFormSG" label-width="200px" :rules="rulesSG"
                    ref="ruleFormSG" size="small" class="ContractorFormBox">
                    <el-col :span="10">
                      <el-form-item label="施工队伍营业等级" prop="businessLevel">
                        <el-input v-model="ruleFormSG.businessLevel" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="责任书签订日期" prop="doucumentSignTime">
                        <el-date-picker v-model="ruleFormSG.doucumentSignTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="责任书到期日期" prop="doucumentDueTime">
                        <el-date-picker v-model="ruleFormSG.doucumentDueTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="统一社会信用代码" prop="creditCode">
                        <el-input v-model="ruleFormSG.creditCode" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="营业执照字号" prop="businessLicenseNum">
                        <el-input v-model="ruleFormSG.businessLicenseNum" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="特种设备安装许可证" prop="itc">
                        <el-input v-model="ruleFormSG.itc" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="施工队伍负责人" prop="principal">
                        <el-input v-model="ruleFormSG.principal" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="施工队负责人联系电话" prop="principalTel">
                        <el-input v-model="ruleFormSG.principalTel" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="施工队负责人身份证" prop="principalTel">
                        <el-input v-model="ruleFormSG.principalIdCard" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="安全负责人" prop="safetyPrincipal">
                        <el-input v-model="ruleFormSG.safetyPrincipal" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="安全负责人联系电话" prop="safetyPrincipalTel">
                        <el-input v-model="ruleFormSG.safetyPrincipalTel" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="安全负责人身份证" prop="safetyPrincipalTel">
                        <el-input v-model="ruleFormSG.safetyPrincipalIdCard" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="进厂日期" prop="intoPlantTime">
                        <el-date-picker v-model="ruleFormSG.intoPlantTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="考核日期" prop="assessTime">
                        <el-date-picker v-model="ruleFormSG.assessTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="是否在黑名单" prop="blacklist">
                        <el-radio-group v-model="ruleFormSG.blacklist" size="small">
                          <el-radio-button :label="0">否</el-radio-button>
                          <el-radio-button :label="1">是</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="施工单位简介" prop="intro">
                        <el-input v-model="ruleFormSG.intro" style="width: 92%" type="textarea" :rows="3" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="">
                        <el-button type="primary" @click="drawerSubmitSG">保存</el-button>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>


              <el-tab-pane label="承包商评定管理" name="seventh">
                <el-button size="small" type="primary" style="margin-bottom: 15px" @click="drawerAddBtnPD">{{ tableStatusPD ? '新增' : '返回列表' }}</el-button>
                <!-- 承包商评定管理表格 -->
                <div style="height: 600px;overflow: auto">
                  <div v-if="tableStatusPD">
                    <Table
                      border
                      style="margin: auto auto;"
                      max-height="600"
                      :columns="contractorEvaluate"
                      :data="evaluateData"
                    >
                    <template slot-scope="{ row }" slot="assessTime">{{ row.assessTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="assessResult">{{ row.assessResult === 1 ? "合格承包商" : "不合格承包商" }}</template>
                    <template slot-scope="{ row }" slot="operation">
                      <el-link :underline="false" type="primary" @click="drawerEditPD(row)">编辑</el-link>
                      <span style="color: #e8e8e8; margin: 0 5px">|</span>
                      <el-link :underline="false" type="danger" @click="drawerDeletePD(row.id)">删除</el-link>
                    </template>
                    </Table>
                    <div style="textAlign: right;margin-top: 10px">
                      <Page :current="drawerCurPagePD" :total="drawerTotalPD" :page-size="drawerPageSizePD" @on-change="drawerPageChangePD" />
                    </div>
                  </div>
                  <!-- 承包商施工管理新增/编辑的表单 -->
                  <el-form v-else :model="ruleFormPD" label-width="200px" :rules="rulesPD"
                    ref="ruleFormPD" size="small" class="ContractorFormBox">
                    <el-col :span="10">
                      <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleFormPD.title" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="被考核承包商" prop="contractorsName">
                        <el-input v-model="ruleFormPD.contractorsName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="考核部门" prop="assessDep">
                        <el-input v-model="ruleFormPD.assessDep" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="考核日期" prop="assessTime">
                        <el-date-picker v-model="ruleFormPD.assessTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="总分" prop="score">
                        <el-input v-model="ruleFormPD.score" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="考核结果" prop="assessResult">
                        <el-radio-group v-model="ruleFormPD.assessResult" size="small">
                          <el-radio-button :label="1">合格承包商</el-radio-button>
                          <el-radio-button :label="2">不合格承包商</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="审批前类别" prop="beforeClass">
                        <el-input v-model="ruleFormPD.beforeClass" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="审批认定类别" prop="assessClass">
                        <el-input v-model="ruleFormPD.assessClass" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="承包商所在厂区" prop="place">
                        <el-input v-model="ruleFormPD.place" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="承包商在厂状态" prop="status">
                        <el-input v-model="ruleFormPD.status" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="">
                        <el-button type="primary" @click="drawerSubmitPD">保存</el-button>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>


              <el-tab-pane label="承包商违章记录" name="eighth">
                <el-button size="small" type="primary" style="margin-bottom: 15px" @click="drawerAddBtnWZ">{{ tableStatusWZ ? '新增' : '返回列表' }}</el-button>
                <!-- 承包商违章记录表格 -->
                <div style="height: 600px;overflow: auto">
                  <div v-if="tableStatusWZ">
                    <Table
                      border
                      style="margin: auto auto;"
                      max-height="600"
                      :columns="violationRecordCol"
                      :data="violationRecord"
                    >
                    <template slot-scope="{ row }" slot="violationTime">{{ row.violationTime | timeFilter }}</template>
                    <template slot-scope="{ row }" slot="operation">
                      <el-link :underline="false" type="primary" @click="drawerEditWZ(row)">编辑</el-link>
                      <span style="color: #e8e8e8; margin: 0 5px">|</span>
                      <el-link :underline="false" type="danger" @click="drawerDeleteWZ(row.id)">删除</el-link>
                    </template>
                    </Table>
                    <div style="textAlign: right;margin-top: 10px">
                      <Page :current="drawerCurPageWZ" :total="drawerTotalWZ" :page-size="drawerPageSizeWZ" @on-change="drawerPageChangeWZ" />
                    </div>
                  </div>
                  <!-- 承包商违章记录新增/编辑的表单 -->
                  <el-form v-else :model="ruleFormWZ" label-width="200px" :rules="rulesWZ"
                    ref="ruleFormWZ" size="small" class="ContractorFormBox">
                    <el-col :span="10">
                      <el-form-item label="项目名称" prop="projectName">
                        <el-input v-model="ruleFormWZ.projectName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="违章日期" prop="violationTime">
                        <el-date-picker v-model="ruleFormWZ.violationTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="处理结果" prop="result">
                        <el-input v-model="ruleFormWZ.result" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="违章人姓名" prop="violationEmpName">
                        <el-input v-model="ruleFormWZ.violationEmpName" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="20">
                      <el-form-item label="">
                        <el-button type="primary" @click="drawerSubmitWZ">保存</el-button>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-drawer>
    </div>
</template>

<script>
import {
  contractorConManagerAdd, contractorConManagerEdit,
  contractorConManagerList, contractorConManagerDelete,
  contractorEvaManagerAdd, contractorEvaManagerEdit,
  contractorEvaManagerList, contractorEvaManagerDelete,
  conViolationRecordAdd, conViolationRecordEdit,
  conViolationRecordList, conViolationRecordDelete
} from "@/api/processManager"
import { downLoadDocument } from "@/api/downLoad"
export default {
  data() {
    return {
      picecDataId: '', // 记录点击了某一条数据（该条数据的id）
      examCol: [
        { title: "考试名称", key: "questionnaireName" },
        { title: "考题量", key: "questionNum" },
        { title: "答题开始时间", key: "startAnswerTime" },
        { title: "答题结束时间", key: "endAnswerTime" },
        { title: "得分", key: "score" },
        { title: "是否考试", slot: "isExam" },
        { title: "考试状态", slot: "isPass" },
        { title: "答题人", key: "empName" }
      ],
      constructionCol: [
        { title: '施工队伍营业等级', key: 'businessLevel', width: 120 },
        { title: '责任书签订日期', slot: 'doucumentSignTime', width: 120 },
        { title: '责任书到期日期', slot: 'doucumentDueTime', width: 120 },
        { title: '统一社会信用代码', key: 'creditCode', width: 120 },
        { title: '营业执照字号', key: 'businessLicenseNum', width: 120 },
        { title: '特种设备安装许可证', key: 'itc', width: 120 },
        { title: '施工队伍负责人', key: 'principal', width: 120 },
        { title: '施工队负责人联系电话', key: 'principalTel', width: 120 },
        { title: '安全负责人', key: 'safetyPrincipal', width: 120 },
        { title: '安全负责人联系电话', key: 'safetyPrincipalTel', width: 120 },
        { title: '进厂日期', slot: 'intoPlantTime', width: 120 },
        { title: '考核日期', slot: 'assessTime', width: 120 },
        { title: '施工单位简介', key: 'intro', width: 120, tooltip: true },
        { title: '是否在黑名单', slot: 'blacklist', width: 120 },
        { title: '操作', slot: 'operation', width: 120, fixed: 'right' }
      ],
      constructionList: [],
      contractorEvaluate: [
        { title: '标题', key: 'title' },
        { title: '被考核承包商', key: 'contractorsName' },
        { title: '考核部门', key: 'assessDep' },
        { title: '考核日期', slot: 'assessTime' },
        { title: '总分', key: 'score'},
        { title: '考核结果', slot: 'assessResult' },
        { title: '审批前类别', key: 'beforeClass' },
        { title: '审批认定类别', key: 'assessClass' },
        { title: '承包商所在厂区', key: 'place' },
        { title: '承包商在厂状态', key: 'status' },
        { title: '操作', slot: 'operation', width: 120 }
      ],
      evaluateData: [],
      violationRecordCol: [
        { title: '项目名称', key: 'projectName' },
        { title: '违章日期', slot: 'violationTime' },
        { title: '处理结果', key: 'result' },
        { title: '违章人姓名', key: 'violationEmpName' },
        { title: '操作', slot: 'operation', width: 120 }
      ],
      violationRecord: [],
      eduCol: [
        { title: "工号", key: "empNo" },
        { title: "培训组织", key: "organizationName" },
        { title: "课时(小时)", key: "duration" },
        { title: "培训课程", key: "courseName" },
        { title: "计划开始时间", key: "estStartTime" },
        { title: "计划结束时间", key: "estEndTime" },
        { title: "开始时间", key: "actualStartTime" },
        { title: "结束时间", key: "actualEndTime" }
      ],
      // eduExam:[],
      // examRecord: [],
      userTotal: 0,
      userLimit: 10,
      userCol: [
        { title: "头像", slot: "header", width: 100 },
        { title: "姓名", key: "name" },
        { title: "性别", slot: "sex", width: 100 },
        { title: "工号", key: "empNo" },
        { title: "账户", key: "account" }
      ],
      userIsShow: false,
      infoForm: {},
      activeName: "first",
      drawer: false,
      blackStatus: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      status: "",
      type: "",
      //  0_ 准承包商,1_ 合格承包商，2_ 不合格承包商
      types: [
        { label: "准承包商", value: 0 },
        { label: "合格承包商", value: 1 },
        { label: "不合格承包商", value: 2 }
      ],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      pageTotal: 0,
      total: 0,
      fileNameOrTag: "",
      sourceTypeId: 5,
      columns: [
        { title: "单位名称", slot: "contrName" },
        { title: "社会信用代码", key: "creditCode" },
        { title: "承包商电话", key: "contrPhone" },
        { title: "负责人", key: "chargerName" },
        { title: "安全负责人", key: "safetyCharger" },
        { title: "责任书到期时间", slot: "days" },
        { title: "合作状态", key: "cooperationStatus" },
        { title: "黑名单状态", slot: "blackStatus" },
        { title: "操作", slot: "action", align: "center", width: 150 }
      ],
      data: [],
      certificateStr: [],
      attachmentsStr: [],
      thisPage: 1,
      //
      ruleFormSG: {},
      rulesSG: {
        businessLevel: [{ required: true, message: '请输入' }],
        doucumentSignTime: [{ required: true, message: '请选择' }],
        doucumentDueTime: [{ required: true, message: '请选择' }],
        creditCode: [{ required: true, message: '请输入' }],
        businessLicenseNum: [{ required: true, message: '请输入' }],
        itc: [{ required: true, message: '请输入' }],
        principal: [{ required: true, message: '请输入' }],
        principalTel: [{ required: true, message: '请输入' }],
        safetyPrincipal: [{ required: true, message: '请输入' }],
        safetyPrincipalTel: [{ required: true, message: '请输入' }],
        intoPlantTime: [{ required: true, message: '请选择' }],
        assessTime: [{ required: true, message: '请选择' }],
        intro: [{ required: true, message: '请输入' }],
        blacklist: [{ required: true, message: '请选择' }],
        principalIdCard: [{ required: true, message: '请输入' }],
        safetyPrincipalIdCard: [{ required: true, message: '请输入' }],
      },
      // 控制显示表格还是表单
      tableStatusSG: true,
      drawerTotalSG: 0,
      drawerPageSizeSG: 10,
      drawerCurPageSG: 1,
      // 评定管理
      ruleFormPD: {},
      rulesPD: {
        title: [{ required: true, message: '请输入' }],
        contractorsName: [{ required: true, message: '请输入' }],
        assessDep: [{ required: true, message: '请输入' }],
        assessTime: [{ required: true, message: '请选择' }],
        score: [{ required: true, message: '请输入' }],
        assessResult: [{ required: true, message: '请选择' }],
        beforeClass: [{ required: true, message: '请输入' }],
        assessClass: [{ required: true, message: '请输入' }],
        place: [{ required: true, message: '请输入' }],
        status: [{ required: true, message: '请输入' }],
      },
      tableStatusPD: true,
      drawerTotalPD: 0,
      drawerPageSizePD: 10,
      drawerCurPagePD: 1,
      // 违章记录
      ruleFormWZ: {},
      rulesWZ: {
        projectName: [{ required: true, message: '请输入' }],
        violationTime: [{ required: true, message: '请选择' }],
        result: [{ required: true, message: '请输入' }],
        violationEmpName: [{ required: true, message: '请输入' }],
      },
      tableStatusWZ: true,
      drawerTotalWZ: 0,
      drawerPageSizeWZ: 10,
      drawerCurPageWZ: 1,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getNowDate() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      return y + "-" + m + "-" + d;
    },
    DateDiff(sDate1) {
      //sDate1和 sDate2 是2002-12-18格式
      let sDate2 = this.getNowDate();
      var aDate, oDate1, oDate2, iDays;
      aDate = sDate1.split("-");
      oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为12-18-2002格式
      aDate = sDate2.split("-");
      oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
      let result = this.tab(sDate1, sDate2);
      if (result == 1) {
        return "剩余" + iDays + "天";
      } else {
        return "过期" + iDays + "天";
      }
    },
    tab(date1, date2) {
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        return 1;
      } else {
        return 0;
      }
    },
    getDataInfo(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander("/contractorInfo/info/" + id)
        .openLoad()
        .startGet()
        .then(res => {
          this.drawer = true;
          this.infoForm = res.body.data;
          let files = JSON.parse(this.infoForm.certificateStr);
          this.certificateStr = []
          if (files) {
            this.certificateStr = files
          }

          let files1 = JSON.parse(this.infoForm.attachmentsStr);
          this.attachmentsStr = []
          if (files1) {
            this.attachmentsStr = files1
          }
          // console.log(this.attachmentsStr);
          // console.log(this.certificateStr);
        });
    },
    showDrawer(row) {
      this.infoForm = {};
      this.picecDataId = row.id
      this.getDataInfo(row.id);
    },
    handleClose() {
      this.drawer = false;
      this.activeName = 'first'
      this.tableStatusSG = true
      this.tableStatusPD = true
      this.tableStatusWZ = true
    },
    changeData(val) {
      this.getDangerPlan(1);
    },
    getData() {
      this.getDangerPlan(1);
    },
    getDangerPlan: function(page) {
      let url =
        "/contractorInfo/list_all?limit=" +
        10 +
        "&curPage=" +
        page +
        "&nameOrNumParam=" +
        this.fileNameOrTag +
        "&genre=" +
        this.status +
        "&contrSort=" +
        this.type;

      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startGet()
        .then(res => {
          this.data = res.body.data;
          for (var i = 0; i < this.data.length; i++) {
            var planTime = this.data[i].duetime.split(" ")[0];
            let days = this.DateDiff(planTime);
            if (!days) {
              days = "剩余0天";
            }
            this.data[i].days = days;
          }
          this.currentPage = res.body.page;
          this.pageTotal = res.body.pageTotal;
          this.total = res.body.cum;
        });
    },
    handleAdd() {
      this.$router.push({
        path: "addContrac"
      });
    },
    handChange(row) {
      this.$router.push({
        name: "addContrac",
        params: { key: row }
      });
    },
    handleDel(row) {
      // console.log(row)
      this.$confirm(`删除承包商 "${row.contrName}", 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander("/contractorInfo/delete/" + row.id)
            .openLoad()
            .startPost()
            .then(res => {
              this.getData();
              this.$message.success("删除成功");
            });
        })
        .catch(() => {
          return;
        });
    },
    tabClick(row) {
      if(row.name === 'sixth') {
        this.getContractorConManList()
      }
      if(row.name === 'seventh') {
        this.getEvaluateDataList()
      }
      if(row.name === 'eighth') {
        this.getViolationRecordList()
      }
    },
    // 抽屉里面的事件
    // 施工tab栏的事件
    drawerAddBtnSG() {
      this.tableStatusSG = !this.tableStatusSG
      this.ruleFormSG = {}
      if(this.tableStatusSG) {
        this.$refs['ruleFormSG'].resetFields();
      }
    },
    // 列表
    getContractorConManList() {
      contractorConManagerList({ curPage: this.drawerCurPageSG, limit: this.drawerPageSizeSG, isPage: 1, contractorsId: this.picecDataId }).then(res => {
        this.constructionList = res.body.data
        this.drawerTotalSG = res.body.cum
      })
    },
    drawerPageChangeSG(val) {
      this.drawerCurPageSG = val
      this.getContractorConManList()
    },
    // 保存按钮
    drawerSubmitSG() {
      this.$refs['ruleFormSG'].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.ruleFormSG.id !== undefined && this.ruleFormSG.id !== null && this.ruleFormSG.id !== '') {
            contractorConManagerEdit({ ...this.ruleFormSG, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnSG()
              this.getContractorConManList()
            })
          }
          // 新增
          else {
            contractorConManagerAdd({ ...this.ruleFormSG, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnSG()
              this.getContractorConManList()
            })
          }
        } else {
          return false;
        }
      })
    },
    // 编辑按钮
    drawerEditSG(row) {
      this.ruleFormSG = { ...row }
      this.tableStatusSG = false
    },
    drawerDeleteSG(id) {
      contractorConManagerDelete(id).then(res => {
        this.$message.success('删除成功')
        this.getContractorConManList()
      })
    },

    // 评定管理的事件
    // 评定tab栏的事件
    drawerAddBtnPD() {
      this.tableStatusPD = !this.tableStatusPD
      this.ruleFormPD = {}
      if(this.tableStatusPD) {
        this.$refs['ruleFormPD'].resetFields();
      }
    },
    // 列表
    getEvaluateDataList() {
      contractorEvaManagerList({ curPage: this.drawerCurPagePD, limit: this.drawerPageSizePD, isPage: 1, contractorsId: this.picecDataId }).then(res => {
        this.evaluateData = res.body.data
        this.drawerTotalPD = res.body.cum
      })
    },
    drawerPageChangePD(val) {
      this.drawerCurPagePD = val
      this.getEvaluateDataList()
    },
    // 保存按钮
    drawerSubmitPD() {
      this.$refs['ruleFormPD'].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.ruleFormPD.id !== undefined && this.ruleFormPD.id !== null && this.ruleFormPD.id !== '') {
            contractorEvaManagerEdit({ ...this.ruleFormPD, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnPD()
              this.getEvaluateDataList()
            })
          }
          // 新增
          else {
            contractorEvaManagerAdd({ ...this.ruleFormPD, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnPD()
              this.getEvaluateDataList()
            })
          }
        } else {
          return false;
        }
      })
    },
    // 编辑按钮
    drawerEditPD(row) {
      this.ruleFormPD = { ...row }
      this.tableStatusPD = false
    },
    drawerDeletePD (id) {
      contractorEvaManagerDelete(id).then(res => {
        this.$message.success('删除成功')
        this.getEvaluateDataList()
      })
    },


    // 违章记录
    // 违章记录tab栏的事件
    drawerAddBtnWZ() {
      this.tableStatusWZ = !this.tableStatusWZ
      this.ruleFormWZ = {}
      if(this.tableStatusWZ) {
        this.$refs['ruleFormWZ'].resetFields();
      }
    },
    // 列表
    getViolationRecordList() {
      conViolationRecordList({ curPage: this.drawerCurPageWZ, limit: this.drawerPageSizeWZ, isPage: 1, contractorsId: this.picecDataId }).then(res => {
        this.violationRecord = res.body.data
        this.drawerTotalWZ = res.body.cum
      })
    },
    drawerPageChangeWZ(val) {
      this.drawerCurPageWZ = val
      this.getViolationRecordList()
    },
    // 保存按钮
    drawerSubmitWZ() {
      this.$refs['ruleFormWZ'].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.ruleFormWZ.id !== undefined && this.ruleFormWZ.id !== null && this.ruleFormWZ.id !== '') {
            conViolationRecordEdit({ ...this.ruleFormWZ, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnWZ()
              this.getViolationRecordList()
            })
          }
          // 新增
          else {
            conViolationRecordAdd({ ...this.ruleFormWZ, contractorsId: this.picecDataId }).then(res => {
              this.$message.success('保存成功')
              this.drawerAddBtnWZ()
              this.getViolationRecordList()
            })
          }
        } else {
          return false;
        }
      })
    },
    // 编辑按钮
    drawerEditWZ(row) {
      this.ruleFormWZ = { ...row }
      this.tableStatusWZ = false
    },
    drawerDeleteWZ (id) {
      conViolationRecordDelete(id).then(res => {
        this.$message.success('删除成功')
        this.getViolationRecordList()
      })
    },
    // 详情抽屉里面的文件下载
    downloadBtn(url, name) {
      downLoadDocument(url, name)
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}
.ContractorFormBox /deep/ .el-input {
  width: 80%
}
</style>
